var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:['item-icon', { 'is-disabled': _vm.disabled }],attrs:{"width":"24","height":"24","src":_vm.active ? require('../image/thumbs-down-red.png') : require('../image/thumbs-down.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }